module.exports = __webpack_public_path__ + "static/media/timeless-sash-windows.79f10519.png";